import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import Plugin from '@jbrowse/core/Plugin';
import InternetAccountType from '@jbrowse/core/pluggableElementTypes/InternetAccountType';
import { configSchema as OAuthConfigSchema, modelFactory as OAuthInternetAccountModelFactory } from './OAuthModel';
import { configSchema as ExternalTokenConfigSchema, modelFactory as ExternalTokenInternetAccountModelFactory } from './ExternalTokenModel';
import { configSchema as HTTPBasicConfigSchema, modelFactory as HTTPBasicInternetAccountModelFactory } from './HTTPBasicModel';
import { configSchema as DropboxOAuthConfigSchema, modelFactory as DropboxOAuthInternetAccountModelFactory } from './DropboxOAuthModel';
import { configSchema as GoogleDriveOAuthConfigSchema, modelFactory as GoogleDriveOAuthInternetAccountModelFactory } from './GoogleDriveOAuthModel';
var AuthenticationPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(AuthenticationPlugin, _Plugin);
  function AuthenticationPlugin() {
    var _this;
    _classCallCheck(this, AuthenticationPlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AuthenticationPlugin).apply(this, arguments));
    _this.name = 'AuthenticationPlugin';
    _this.exports = {
      OAuthConfigSchema: OAuthConfigSchema,
      OAuthInternetAccountModelFactory: OAuthInternetAccountModelFactory,
      ExternalTokenConfigSchema: ExternalTokenConfigSchema,
      ExternalTokenInternetAccountModelFactory: ExternalTokenInternetAccountModelFactory,
      HTTPBasicConfigSchema: HTTPBasicConfigSchema,
      HTTPBasicInternetAccountModelFactory: HTTPBasicInternetAccountModelFactory,
      DropboxOAuthConfigSchema: DropboxOAuthConfigSchema,
      DropboxOAuthInternetAccountModelFactory: DropboxOAuthInternetAccountModelFactory,
      GoogleDriveOAuthConfigSchema: GoogleDriveOAuthConfigSchema,
      GoogleDriveOAuthInternetAccountModelFactory: GoogleDriveOAuthInternetAccountModelFactory
    };
    return _this;
  }
  _createClass(AuthenticationPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      pluginManager.addInternetAccountType(function () {
        return new InternetAccountType({
          name: 'OAuthInternetAccount',
          configSchema: OAuthConfigSchema,
          stateModel: OAuthInternetAccountModelFactory(OAuthConfigSchema)
        });
      });
      pluginManager.addInternetAccountType(function () {
        return new InternetAccountType({
          name: 'ExternalTokenInternetAccount',
          configSchema: ExternalTokenConfigSchema,
          stateModel: ExternalTokenInternetAccountModelFactory(ExternalTokenConfigSchema)
        });
      });
      pluginManager.addInternetAccountType(function () {
        return new InternetAccountType({
          name: 'HTTPBasicInternetAccount',
          configSchema: HTTPBasicConfigSchema,
          stateModel: HTTPBasicInternetAccountModelFactory(HTTPBasicConfigSchema)
        });
      });
      pluginManager.addInternetAccountType(function () {
        return new InternetAccountType({
          name: 'DropboxOAuthInternetAccount',
          configSchema: DropboxOAuthConfigSchema,
          stateModel: DropboxOAuthInternetAccountModelFactory(DropboxOAuthConfigSchema)
        });
      });
      pluginManager.addInternetAccountType(function () {
        return new InternetAccountType({
          name: 'GoogleDriveOAuthInternetAccount',
          configSchema: GoogleDriveOAuthConfigSchema,
          stateModel: GoogleDriveOAuthInternetAccountModelFactory(GoogleDriveOAuthConfigSchema)
        });
      });
    }
  }]);
  return AuthenticationPlugin;
}(Plugin);
export { AuthenticationPlugin as default };
export { OAuthConfigSchema, OAuthInternetAccountModelFactory, ExternalTokenConfigSchema, ExternalTokenInternetAccountModelFactory, HTTPBasicConfigSchema, HTTPBasicInternetAccountModelFactory, DropboxOAuthConfigSchema, DropboxOAuthInternetAccountModelFactory, GoogleDriveOAuthConfigSchema, GoogleDriveOAuthInternetAccountModelFactory };